
export const Feature = ({descripcion}) => {
    return(
        <div>
            <span className="icono">{"[ ] "}</span>
            <p className="inline">{descripcion}</p>
        </div>
    )
}